import { UserRoleENUM, UserDTO, UserTypeENUM } from '../DTOs/UserDTO';
import { PriceBreakdown } from './PriceBreakdown';

export class User {
  private _id: number | undefined;
  private _username: string;
  private _companyId: string;
  private _userType: UserTypeENUM;
  private _roles: UserRoleENUM;
  private _resetPassword: boolean;
  private _priceBreakdown?: PriceBreakdown;

  constructor(
    id: number | undefined,
    username: string,
    companyId: string,
    userType: UserTypeENUM,
    roles: UserRoleENUM,
    resetPassword: boolean,
    priceBreakdown?: PriceBreakdown,
  ) {
    this._id = id;
    this._username = username;
    this._companyId = companyId;
    this._userType = userType;
    this._roles = roles;
    this._resetPassword = resetPassword;
    this._priceBreakdown = priceBreakdown;
  }

  public static fromDTO(userDto: UserDTO) {
    return new User(
      userDto.id,
      userDto.username,
      userDto.companyId,
      userDto.userType,
      userDto.roles,
      userDto.resetPassword,
      userDto.priceBreakdown,
    );
  }

  public toDTO() {
    return new UserDTO(
      this._id,
      this._username,
      this._companyId,
      this._userType,
      this._roles,
      this._resetPassword,
      this._priceBreakdown,
    );
  }

  public getId(): number | undefined {
    return this._id;
  }

  public setId(_id: number): void {
    this._id = _id;
  }

  public getUsername(): string {
    return this._username;
  }

  public setUsername(_username: string): void {
    this._username = _username;
  }

  public getCompanyId(): string {
    return this._companyId;
  }

  public setCompanyId(_companyId: string): void {
    this._companyId = _companyId;
  }

  public getUserType(): UserTypeENUM {
    return this._userType;
  }

  public setUserType(_userType: UserTypeENUM): void {
    this._userType = _userType;
  }

  public getRoles(): UserRoleENUM {
    return this._roles;
  }

  public setRoles(_roles: UserRoleENUM): void {
    this._roles = _roles;
  }

  public isResetPassword(): boolean {
    return this._resetPassword;
  }

  public setResetPassword(_resetPassword: boolean): void {
    this._resetPassword = _resetPassword;
  }

  public getPriceBreakdown(): PriceBreakdown | undefined {
    return this._priceBreakdown;
  }

  public setPriceBreakdown(priceBreakdown: PriceBreakdown | undefined): void {
    this._priceBreakdown = priceBreakdown;
  }
}
